import { Member } from './member.model';

export class InternalMember extends Member {
  /* Data from Academy Presential API */
  identifier?: string;
  link?: string;

  /* Data from Search API */
  photoUrl?: string;

  /* Data from Decathlon Enterprise Directory (LDAP) */
  role?: string;
  c?: any;
  uid?: string;
  job?: string;
  branch?: string[];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  cost_center?: string;
  site?: string[];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  job_name?: string;
  bn?: string;
  generic?: string[];
  sex?: string;
  department?: string[];
  state?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  service_name?: string;
  service?: string[];
  uuid?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  display_name?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  given_name?: string[];
  mail?: string[];
  manager?: string[] | InternalMember[];
  mobile?: string[];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  preferred_language?: string;
  title?: string[];
  sn?: string[];
  lastName?: string;

  constructor(values= {}) {
    super(values);

    if (values['ldapData']) {
      Object.assign(this, values['ldapData']);
    }
  }
}
